import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";
import CreateInvoicePayment from "../../../../components/Invoices/InvoicePayment/CreateInvoicePayment";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import {
  createInvoicePayment,
  fetchInvoicePaymentModeDD,
} from "../../../../Redux/Actions/invoice";

const CreateInvoicePaymentScreen = (props) => {
  const {
    closeDialog,
    selectedInvoiceRecord,
    createInvoicePayment,
    isLoading,
    isCreateInvoicePaymentSuccess,
    isCreateInvoicePaymentError,
    fetchInvoicePaymentModeDD,
    invoicePaymentModeDD,
  } = props;

  useEffect(() => {
    fetchInvoicePaymentModeDD();
  }, []);

  const getToastProps = () => {
    if (isCreateInvoicePaymentSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Invoice Payment Created Successfully",
        shouldShowToast: true,
      };
    }
    if (isCreateInvoicePaymentError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while creating Invoice Payment",
        shouldShowToast: true,
      };
    }
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  const invoicePaymentProps = {
    closeDialog,
    selectedInvoiceRecord,
    createInvoicePayment,
    invoicePaymentModeDD,
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <div className="mt-2">
        <EzToast {...getToastProps()} />
        <CreateInvoicePayment {...invoicePaymentProps} />
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  createInvoicePayment: (payload) => dispatch(createInvoicePayment(payload)),
  fetchInvoicePaymentModeDD: () => dispatch(fetchInvoicePaymentModeDD()),
});

const mapStateToProps = (state, ownProps) => {
  console.log("mapStateInvoicePayments", state);
  return {
    isLoading: selectFromInvoicesReducer(state, "isLoading"),
    invoicePaymentModeDD: selectFromInvoicesReducer(
      state,
      "invoicePaymentModeDD"
    ),
    isCreateInvoicePaymentSuccess: selectFromInvoicesReducer(
      state,
      "isCreateInvoicePaymentSuccess"
    ),
    isCreateInvoicePaymentError: selectFromInvoicesReducer(
      state,
      "isCreateInvoicePaymentError"
    ),
    ...ownProps,
  };
};

const selectFromInvoicesReducer = (state, path) => {
  return selectInvoicesReducer(state)[path];
};

const selectInvoicesReducer = ({ invoiceReducer }) => {
  return invoiceReducer;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateInvoicePaymentScreen);
